import Chart from "common/components/Chart/Chart";
import { useWordCloudChart } from "hooks/chart/UseWordCloudChart";
import React, { useEffect } from "react";

const WordCloudChart = ({ data, xAxis }) => {
    const {
        options: optionsWordCloud,
        setOptions: setWordCloudChart,
        showLoading,
        hideLoading,
        onChartReady,
    } = useWordCloudChart();

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            showLoading(); // 🔹 Mostrar loading

            setTimeout(() => {
                setWordCloudChart({
                    ...optionsWordCloud,
                    series: [
                        {
                            ...optionsWordCloud.series[0],
                            data: Object.entries(data).map(([key, value]) => ({
                                name: key,
                                weight: value,
                            })),
                        },
                    ],
                });
                hideLoading();
            }, 100);
        } else {
            setWordCloudChart({
                ...optionsWordCloud,
                series: [
                    {
                        ...optionsWordCloud.series[0],
                        data: [],
                    },
                ],
            });
        }
    }, [data]);

    return <Chart options={optionsWordCloud} onChartReady={onChartReady} />;
};

export default WordCloudChart;
